import React from 'react'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import TextContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import {useAttendeeVariables} from 'Event'
import QuestionIcon from 'Event/Sponsors/QuestionIcon'
import {Sponsor} from 'Event/Sponsors'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'

type BodyProps = {
  sponsor: Sponsor
  toggleForm: () => void
  textColor: string
  id: string
}

export default function Content(props: BodyProps) {
  const {sponsor, id, textColor} = props
  const v = useAttendeeVariables()
  const {sponsors} = useSimpleBlogTemplate()
  const nameColor = sponsors.nameColor ?? textColor

  return (
    <Box color={textColor}>
      <SponsorHeader>
        <StyledTypography variant="h5" $textColor={nameColor}>
          {v(sponsor.name)}
        </StyledTypography>
        <StyledQuestionIcon
          sponsor={sponsor}
          onClick={props.toggleForm}
          id={id}
        />
      </SponsorHeader>
      <StyledTextContent>{v(sponsor.description)}</StyledTextContent>
    </Box>
  )
}

const Box = styled.div`
  color: ${(props) => props.color};
  width: 100%;
`

const StyledTypography = styled(Typography)<{$textColor: string}>`
  color: ${(props) => props.$textColor};
`

const StyledQuestionIcon = styled(QuestionIcon)`
  margin-right: 10px;
`

const SponsorHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledTextContent = styled(TextContent)`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    display: initial;
  }
`
